<template lang="html">
  <div class="google-ad-side-container">
    <div class="google-ad-side-1" id='div-gpt-ad-side-1'>
    </div>
    <div class="google-ad-side-2" id='div-gpt-ad-side-2'>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable space-infix-ops */
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
        gptadslots: null,
        refresher: null,
        currentClientHeight: null,
        isEventListenerAdded: false
      }
    },
    created () {
      window.addEventListener('resize', this.didResize)
      this.$eventHub.$on('showGoogleAdSide', this.loadGpt)
      this.$eventHub.$on('hideGoogleAdSide', this.destroyAd)
    },
    mounted () {
      if (this.settings !== undefined) {
        this.loadGpt()
        this.currentClientHeight = document.documentElement.clientHeight
      }
    },
    computed: {
      ...mapGetters({
        settings: 'getSettings',
        showArticleModal: 'getShowArticleModal',
        showGoogleAdSide: 'getShowGoogleAdSide',
        showIssueOverview: 'getShowIssueOverview',
        currentPage: 'getCurrentPage'
      })
    },
    watch: {
      settings: function () {
        this.loadGpt()
      },
      showArticleModal: function (newValue) {
        if (newValue) {
          this.stopRefresh()
          this.destroyAd()
        } else {
          this.loadGpt()
        }
      },
      showIssueOverview: function (newValue) {
        if (newValue) {
          this.stopRefresh()
          this.destroyAd()
        } else if (this.currentPage.firstPage.interstitialAdAfterPage === undefined) {
          this.loadGpt()
        }
      }
    },
    methods: {
      loadGpt () {
        if (this.settings.gptAdCode === undefined ||
          this.settings.gptAdCode === '' ||
          this.gptadslots !== null ||
          !googletag.apiReady) {
          return
        }

        let self = this
        this.gptadslots = []
        googletag.cmd.push(function () {
          var sizeMap = googletag.sizeMapping().addSize([0, 0], []).addSize([1024, 380], [300, 250]).addSize([1024, 710], [[300, 600], [300, 250]]).build()
          self.gptadslots[0] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [[300, 250], [300, 600]], 'div-gpt-ad-side-1').setTargeting('atf', ['Y']).setTargeting('pkg', ['b']).defineSizeMapping(sizeMap).addService(googletag.pubads())

          // add height + section bar + navigation bar + 50% of those.. : 88 + 44 =
          // var sizeMap1 = googletag.sizeMapping().addSize([0, 0], []).addSize([1024, 610], [300, 250]).build()
          // var sizeMap2 = googletag.sizeMapping().addSize([0, 0], []).addSize([1024, 740], [300, 250]).build()
          // self.gptadslots[0] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [300, 250], 'div-gpt-ad-side-1').setTargeting('atf', ['Y']).setTargeting('pkg', ['b']).defineSizeMapping(sizeMap1).addService(googletag.pubads())
          // self.gptadslots[1] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [300, 250], 'div-gpt-ad-side-2').setTargeting('atf', ['Y']).setTargeting('pkg', ['c']).addService(googletag.pubads())
          // googletag.destroySlots()
          googletag.pubads().enableSingleRequest()
          googletag.pubads().setTargeting('pl', ['vendor']).setTargeting('sect', ['CCi'])
          googletag.pubads().setCategoryExclusion('vendor')
          googletag.pubads().collapseEmptyDivs()
          if (!self.isEventListenerAdded) {
            self.isEventListenerAdded = true
            googletag.pubads().addEventListener('slotRenderEnded', function (event) {
              if (!event.isEmpty) {
                if (event.slot.getSlotElementId() === 'div-gpt-ad-side-1') {
                  if (event.size[1] === 250 && document.documentElement.clientHeight > 710) {
                    self.addSecondSlot()
                  } else {
                    self.removeSecondSlot()
                  }
                }
              }
            })
          }

          googletag.enableServices()

          self.startRefresh()

          googletag.display('div-gpt-ad-side-1')
        })
      },
      startRefresh () {
        if (this.refresher !== null) {
          this.stopRefresh()
        }

        let self = this
        // Set timer to refresh gptadslots[1] slots every 30 seconds
        self.refresher = setInterval(function () {
          googletag.pubads().refresh(self.gptadslots)
        }, 30000)
      },
      stopRefresh () {
        clearInterval(this.refresher)
        this.refresher = null
      },
      forceRefresh () {
        googletag.pubads().refresh(self.gptadslots)
      },
      destroyAd () {
        let self = this
        if (this.gptadslots !== null) {
          googletag.cmd.push(function () {
            googletag.destroySlots(self.gptadslots)
            self.gptadslots = null
            self.stopRefresh()
          })
        }
      },
      didResize () {
        let clientHeight = document.documentElement.clientHeight
        if (clientHeight > 380) {
          if ((clientHeight >= 710 && this.currentClientHeight < 710) ||
          (clientHeight < 710 && this.currentClientHeight >= 710)) {
            this.forceRefresh()
          }
        }
        this.currentClientHeight = clientHeight
      },
      addSecondSlot () {
        if (this.gptadslots.length > 1) {
          return
        }
        let self = this
        googletag.cmd.push(function () {
          self.gptadslots[1] = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Online/OtherCGI', [300, 250], 'div-gpt-ad-side-2').setTargeting('atf', ['Y']).setTargeting('pkg', ['c']).addService(googletag.pubads())
          googletag.display('div-gpt-ad-side-2')
          document.getElementById('div-gpt-ad-side-1').style.paddingBottom = '10px'
          document.getElementById('div-gpt-ad-side-2').style.paddingTop = '10px'
        })
      },
      removeSecondSlot () {
        if (this.gptadslots.length < 2) {
          return
        }
        let self = this
        googletag.cmd.push(function () {
          googletag.destroySlots([self.gptadslots[1]])
          self.gptadslots.pop()
          document.getElementById('div-gpt-ad-side-1').style.paddingBottom = '0px'
          document.getElementById('div-gpt-ad-side-2').style.paddingTop = '0px'
        })
      }
    }
  }
  /* eslint-enable no-undef */
  /* eslint-enable space-infix-ops */
</script>


<style lang="scss">
.google-ad-side-container {
  position: absolute;
  top: calc(50% + 44px);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 300px;
  // .google-ad-side-1 {
  //   padding-bottom: 10px;
  // }
  // .google-ad-side-2 {
    // padding-top: 10px;
  // }
}

</style>
